// extracted by mini-css-extract-plugin
export default {"container":"Richard_container__Qj+d+","mimo":"Richard_mimo__qoKvN","textBox":"Richard_textBox__YTwzq","textList":"Richard_textList__3xD1B"};